<script setup lang="ts">
// types
import type { FaqGroup } from '@ts-sections/section-faq-multiple/interfaces'
// hooks
import { useBlockFaqGroup } from '@hooks/blocks/block-faq-group.hook'
// components
import BlockFaqItem from '@Blocks/BlockFaqItem.vue'

defineOptions({
  name: 'BlockFaqGroup',
})

defineProps<{
  group: FaqGroup
}>()

const { refOpenIndexes, handleToggle } = useBlockFaqGroup()
</script>

<template>
  <div
    v-if="group.faqItem?.length"
    class="block-faq-group"
  >
    <BlockFaqItem
      v-for="(item, index) in group.faqItem"
      :key="item.id ?? index"
      :item="item"
      :is-open="refOpenIndexes.has(index)"
      @click:toggle="handleToggle(index)"
    />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockFaqGroup.scss" />
